import React from 'react';
import { Tr } from '@chakra-ui/react';
import { useTokens } from '../../../context/TokenProvider';
import { makeMed4 } from '../../../styles/textStyles';
const ExpandableTableRow = ({ isExpanded, onRowClick, children, isUnread, ...rest }) => {
    const tokens = useTokens();
    const getBackgroundColor = () => {
        if (isExpanded)
            return tokens.Layer01;
        if (isUnread)
            return tokens.CanvasTableRowUnread;
        return tokens.Layer02;
    };
    const getTextSettings = () => isUnread
        ? makeMed4(tokens, {
            color: tokens.TextBlack800,
        })
        : undefined;
    const style = {
        borderWidth: isExpanded ? 0 : tokens.BorderWidth01,
        bgColor: getBackgroundColor(),
        td: {
            cursor: 'pointer',
        },
        ...getTextSettings(),
    };
    return (React.createElement(Tr, { "data-testid": "location-findings_table_row_row", sx: style, onClick: onRowClick, ...rest }, children));
};
export default ExpandableTableRow;
